import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import _ from 'lodash';
import React from 'react';
import ListingBadge, { BADGE_MODE } from './base';
import FullWidthBadge from './fullWidthBadge';
import { isShortSale, getBrokerAgent } from './utils';
class ShortSaleBadge extends ListingBadge {
    static title = 'Short Sale';
    static titleIcon = 'sign';
    static content = (_jsxs("span", { children: ["This property is part of Auction.com's Short Sale program.", ' ', _jsx("a", { href: '/lp/learn-more/short-sales/', target: '_blank', children: "Learn more" })] }));
    static shouldBeIncluded(listing, badgeMode) {
        return badgeMode === BADGE_MODE.EXPANDED && isShortSale(listing);
    }
}
class ShortSaleOpenHousesAvailableBadge extends FullWidthBadge {
    static summary = 'Open Houses Scheduled';
    static titleIcon = 'unlock-alt';
    static shouldBeHoisted = true;
    static shouldBeIncluded(listing, badgeMode) {
        if (badgeMode === BADGE_MODE.CONDENSED)
            return false;
        const brokerAgent = getBrokerAgent(listing);
        return (_.get(listing, 'listing_configuration.interior_access_allowed', true) &&
            _.isPlainObject(brokerAgent) &&
            isShortSale(listing));
    }
    get content() {
        return (_jsxs(_Fragment, { children: ["For dates and times or to schedule a private showing", ' ', _jsx("a", { onClick: e => this.emitEvent('interior_access_contact_agent', e), "data-elm-id": 'interior_access_contact_agent', children: "contact the listing agent" }), "."] }));
    }
}
export { ShortSaleBadge, ShortSaleOpenHousesAvailableBadge };
//# sourceMappingURL=shortSale.js.map